import { IProductPageResponse } from "@faire/web-api--source/indigofair/data/IProductPageResponse";
import React, { Suspense } from "react";

import { isAdmin } from "@faire/retailer/lib/isAdmin";
import { isUserMakerEditor } from "@faire/retailer/lib/isUserMakerEditor";
import { useUserStore } from "@faire/retailer/stores/domain/UserStore";
import { LazyInternalProductActions } from "@faire/retailer/views/product/InternalProductActions/LazyInternalProductActions";

export const EmployeeProductActions: React.FC<{
  product: IProductPageResponse.IPdpProduct;
  isBrandActive: boolean;
}> = ({ product, isBrandActive }) => {
  const { hasFaireEmailAddress } = useUserStore(["hasFaireEmailAddress"]);
  if (isAdmin() || hasFaireEmailAddress || isUserMakerEditor()) {
    return (
      <Suspense fallback={null}>
        <LazyInternalProductActions
          product={product}
          isBrandActive={isBrandActive}
        />
      </Suspense>
    );
  }

  return null;
};
